import { Link, Outlet, createRootRouteWithContext, redirect } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/Toaster';
import { isMarketingOnlyMode, marketingOnlyRedirect } from '@/lib/marketingOnly';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: ({ location }) => {
    const destination = marketingOnlyRedirect(location.pathname);
    if (destination) throw redirect({ to: destination });
  },
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[var(--z-modal)] focus:rounded-md focus:bg-[var(--color-surface-elevated)] focus:px-4 focus:py-2 focus:shadow-[var(--shadow-md)]"
      >
        Skip to main content
      </a>
      {isMarketingOnlyMode && <ApplicationPausedBanner />}
      <Outlet />
      <Toaster />
    </>
  );
}

function ApplicationPausedBanner() {
  return (
    <aside
      aria-label="Application status"
      className="border-b border-amber-300 bg-amber-50 px-5 py-3 text-center text-sm text-amber-950"
      data-testid="application-paused-banner"
    >
      <strong>Application access is paused.</strong>{' '}
      <span>The public Pirouette website remains available.</span>{' '}
      <Link to="/contact" className="font-semibold underline">
        Contact Pirouette
      </Link>
    </aside>
  );
}
